import { createAction, props } from '@ngrx/store';
import { pathValid } from './path-valid';

// Inicia el historial de navegación, siempre empieza por el '/hold'.
export const home = createAction('[PATH] Reiniciar Path');

// Añade un nodo al camino.
export const goFront = createAction('[PATH] Avanzar', props<{ path: pathValid }>());

// Adquiere el siguiente punto para volver.
export const goBack = createAction('[PATH] Retroceder');

// Usados para el componente de presupuesto. Debe saber si se abrio en modo 3D.
// Marca su procedencia del 3D.
export const iComingFrom3D = createAction('[PATH] 3D');
// Marca su procedencia NO del 3D.
export const iDontComingFrom3D = createAction('[PATH] 2D');